import {EventItem} from "./event-item";

export class Waypoint {
  constructor(public id?: number,
              public waypointTypeId?: WaypointType,
              public raceId?: number,
              public eventId?: number,
              public city?: string,
              public address?: string,
              public country?: number,
              public additionalMark?: string,
              public descriptionHr?: string,
              public descriptionEn?: string,
              public descriptionIt?: string,
              public descriptionSlo?: string,
              public ordinalNumber?: number,
              public longitude?: number,
              public latitude?: number,
              public pointNameHr?: string,
              public pointNameEn?: string,
              public pointNameSlo?: string,
              public pointNameIt?: string,
              public distanceFromStart?: number,
              public elevation?: number,
              public markerTypes?: number[],
              public limit?: Date,
              public eventItem?:EventItem,
  ) {
  }
}

export enum WaypointType {
  CONTROL_WAYPOINT = 1,
  OTHER_WAYPOINT = 2,
  START_WAYPOINT = 3,
  FINISH_WAYPOINT = 4,
  START_FINISH_WAYPOINT = 5
}
